// @flow

import React, { Component } from 'react';
import { Grid, Row, Col, Button } from 'react-bootstrap/lib';
import { observer } from 'mobx-react';

import 'react-select/dist/react-select.css';

import Spinner from './Spinner';
import ContactInfo from './ContactInfo';
import GetProtectedComponent from '../libs/ProtectedHOC';

type Props = {
  viewer: Object,
  resourcesEditList: Object,
  selectedContactEmail: string,
  languagedata: Object,
  loading: boolean,
  showContactInfoMobile: boolean,
  toggleContactInfoMobile: Function,
  showMeetingRoom: boolean,
  showOtherResource: boolean,
  emails: string[],
  me: Object,
};

@GetProtectedComponent @observer
class Contacts extends Component {
  props: Props;
  render() {
    const { viewer, languagedata, selectedContactEmail, showMeetingRoom, showOtherResource, emails, me } = this.props;

    return (
      <Grid fluid>
        <Row>
          <Col className={`user-info ${(this.props.showContactInfoMobile ? ' show-user-info' : '')}`}>
            <Button
              onClick={() => this.props.toggleContactInfoMobile(false)}
              bsSize="small"
              className="hide-user-info hidden-md hidden-lg"
            >
              <i className="fa fa-close text-muted" />
            </Button>
            {this.props.loading === true ? <Spinner /> : null}
            <ContactInfo
              languagedata={languagedata}
              viewer={viewer}
              selectedContactEmail={selectedContactEmail}
              showMeetingRoom={showMeetingRoom}
              showOtherResource={showOtherResource}
              emails={emails}
              me={me}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default Contacts;



// WEBPACK FOOTER //
// ./src/js/Components/Contacts.js